import { render, staticRenderFns } from "./ConvoGridItem.vue?vue&type=template&id=245a4d48&scoped=true&"
import script from "./ConvoGridItem.vue?vue&type=script&lang=js&"
export * from "./ConvoGridItem.vue?vue&type=script&lang=js&"
import style0 from "./ConvoGridItem.vue?vue&type=style&index=0&id=245a4d48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a4d48",
  null
  
)

export default component.exports